/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Preparation } from '../../models/preparation';

export interface GetOneBasePodosoftPreparationControllerPreparation$Params {
  patientId: number;
  id: number;

/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
  fields?: Array<string>;

/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
  join?: Array<string>;

/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
  cache?: number;
}

export function getOneBasePodosoftPreparationControllerPreparation(http: HttpClient, rootUrl: string, params: GetOneBasePodosoftPreparationControllerPreparation$Params, context?: HttpContext): Observable<StrictHttpResponse<Preparation>> {
  const rb = new RequestBuilder(rootUrl, getOneBasePodosoftPreparationControllerPreparation.PATH, 'get');
  if (params) {
    rb.path('patientId', params.patientId, {});
    rb.path('id', params.id, {});
    rb.query('fields', params.fields, {});
    rb.query('join', params.join, {});
    rb.query('cache', params.cache, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Preparation>;
    })
  );
}

getOneBasePodosoftPreparationControllerPreparation.PATH = '/api/podosoft/{patientId}/preparations/{id}';
